import React from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import { DataGrid } from "devextreme-react";
import useResources from "../../hooks/useResources";
import { getUIProperty, setUIProperty } from "../../redux/slices/uiSlice";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import Loader from "./Loader";
import useResourceStatuses from "../../hooks/useResourceStatus";

const columns = [
  { dataField: "id", caption: "Id", width: 80 },
  { dataField: "name", caption: "Name" },
];

const VendorsModal = () => {
  const { vendorsByType } = useResources();
  const dispatch = useDispatch();
  const { vendorStatus } = useResourceStatuses();
  const type = useSelector((state) => getUIProperty(state, "vendorsModalType"));

  return (
    <Popup
      visible={true}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title={`Vendors by type ${type}`}
      container=".dx-viewport"
      width={600}
      height={800}
    >
      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "Close",
          onClick: () =>
            dispatch(setUIProperty({ name: "showVendorModal", value: false })),
        }}
      />
      {vendorStatus === "pending" && <Loader />}
      <DataGrid
        id="gridContainer"
        rowAlternationEnabled={true}
        dataSource={vendorsByType}
        allowColumnReordering={true}
        showBorders={true}
      >
        {columns.map((column, idx) => (
          <Column
            key={idx}
            cellRender={column.cellRender}
            dataType={column.dataType}
            dataField={column.dataField}
            caption={column.caption}
            width={column.width}
          />
        ))}
      </DataGrid>
    </Popup>
  );
};

export default VendorsModal;
